<template lang='pug'>
  .view-container
    .content-container
      .card-container
        input.title(type="text" v-model='name')
        .date {{moment(record.date).format("LLLL")}}
      .card-container.has-background
        table
          tr.top-header
            td
            td 
              .circle
                .center
                .brilliance(:style="brillianceStyle(scores.rightEye)")
              .text Right Eye
            td 
              .circle
                .center
                .brilliance(:style="brillianceStyle(scores.leftEye)")
              .text Left Eye
          tr.line-below
            td.left-header Horizontal
              br
              | Deviation
            td {{scores.rightEye.x.toFixed(2)}} PD
            td {{scores.leftEye.x.toFixed(2)}} PD
          tr
            td.left-header Vertical
              br
              | Deviation
            td {{scores.rightEye.y.toFixed(2)}} PD
            td {{scores.leftEye.y.toFixed(2)}} PD
      .buttons-container
        .button.accent(@click='done') Done
</template>

<script>
export default {
  data(){
    return {
      moment: require('moment'),
      constant: 11.71 / 2 * 15, // Average iris radius times PD to MM
    }
  },
  computed: {
    scores(){
      let scores = {
        rightEye: {
          x: (this.record.rightEye.center.x - this.record.rightEye.brilliance.x)/this.record.rightEye.radius * this.constant,
          y: (this.record.rightEye.center.y - this.record.rightEye.brilliance.y)/this.record.rightEye.radius * this.constant,
        },
        leftEye: {
          x: (this.record.leftEye.center.x - this.record.leftEye.brilliance.x)/this.record.leftEye.radius * this.constant,
          y: (this.record.leftEye.center.y - this.record.leftEye.brilliance.y)/this.record.leftEye.radius * this.constant,
        },
      }

      return scores
    },
    id(){
      return this.$route.params.id
    },
    record(){
      return this.$store.state.records.find(record => record.id == this.id)
    },
    name: {
      get(){
        return this.record.name
      },
      set(name){
        this.$store.commit('updateRecordName', {
          id: this.record.id,
          name,
        })
      },
    },
  },
  methods: {
    done(){
      this.$router.push({name: "home"})
    },
    brillianceStyle(eye){
      const m = 0.1
      return {
        left: (50 - eye.x * m) + "%",
        top: (50 - eye.y * m) + "%",
      }
    },
  },
  mounted(){
    if(!this.record) this.$router.push({name: "home"})
  },
}
</script>

<style scoped lang="sass">
@import ../sass/variables
$max-width: 30em
.view-container
  background-color: var(--bg2)
  padding-top: 1em

  .card-container
    margin: 1em auto
    padding: 1em
    max-width: $max-width

    .title
      appearance: none
      border: 0
      outline: 0
      background-color: transparent
      font-family: inherit
      font-size: $font-size-3
      color: inherit
      padding: 0
      margin: 0
      width: 100%
      margin-bottom: 0.2em

    .date
      color: var(--bg4)

    &.has-background
      background-color: var(--bg1)
      border-radius: $border-radius-small

    table
      width: 100%
      border-collapse: collapse
      tr
        &.line-below
          border-bottom: 1px solid var(--bg3)
      td
        text-align: center
        padding: 0.8em 0
      .top-header
        text-align: center
        .circle
          margin: auto
          margin-bottom: 1em
          $size: 4em
          width: $size
          height: $size
          border-radius: $size
          background-color: var(--ac1)
          display: flex
          justify-content: center
          align-items: center
          .center
            $size: 2em
            width: $size
            height: $size
            border-radius: $size
            background-color: var(--ac1c)
            opacity: 0.2
          .brilliance
            position: absolute
            $size: 0.5em
            width: $size
            height: $size
            border-radius: $size
            background-color: var(--ac1c)
            transform: translate(-50%, -50%)
        .text
          text-transform: uppercase
          font-weight: bold
      .left-header
        // text-align: left
        color: var(--bg4)

  .buttons-container
    max-width: $max-width
    margin: auto
    margin-top: 2em

</style>
